import { render, staticRenderFns } from "./ConfigurationPremappedContactMappings.vue?vue&type=template&id=46e78ee5&"
import script from "./ConfigurationPremappedContactMappings.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPremappedContactMappings.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPremappedContactMappings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports